// extracted by mini-css-extract-plugin
export default {"around":"TitledLogo_around__KpJpZ","logo":"TitledLogo_logo__aTmx6","title":"TitledLogo_title__u082V"};